import { render, staticRenderFns } from "./messageModal.vue?vue&type=template&id=8de5c65e&scoped=true&"
import script from "./messageModal.vue?vue&type=script&lang=js&"
export * from "./messageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de5c65e",
  null
  
)

export default component.exports